if (!customElements.get('card-product')) {
  class CardProduct extends HTMLElement {
    constructor() {
      super();

      if (this.classList.contains('disabled')) {
        return;
      }

      this.swatches = this.querySelector('.js-swatches');
      this.btnToggleSizes = this.querySelector(
        '.js-btn-toggle-sizes'
      );
      this.defaultMedia = this.querySelector('.js-media-default');

      if (this.btnToggleSizes) {
        this.cartDrawer = document.querySelector('cart-drawer');
        this.sizesContent = this.querySelector('.js-sizes-content');

        // O popup de tamanhos (cópia no <body>) só é criado quando o cliente
        // o abre — ver getDuplicatedSizesContent.
        this.duplicatedSizesContent = null;
        this.onWindowResize = this.onWindowResize.bind(this);
        this.btnToggleSizes.setAttribute('aria-expanded', false);

        if (this.swatches) {
          this.swatches.addEventListener('click', e => {
            const variantId = e.target.getAttribute('data-variant');

            if (variantId) {
              const closestProductCardMedia = e.target.closest('.relative')?.querySelector('.card-product__media');
              const closestProductCardContent = e.target.closest('card-product').querySelector('.card-product__content');

              if (closestProductCardMedia) {
                const currentUrlMedia = closestProductCardMedia.href.split('?')[0];
                const newUrlMedia = currentUrlMedia + '?variant=' + variantId;
                closestProductCardMedia.href = newUrlMedia;
              }

              if (closestProductCardContent) {
                const currentUrlContent = closestProductCardContent.href.split('?')[0];
                const newUrlContent = currentUrlContent + '?variant=' + variantId;
                closestProductCardContent.href = newUrlContent;
              }
            }
          });
        }

        // Abre o popup DESTE card. Antes ele era procurado pelo data-id no
        // container global, e depois de um filtro o mesmo produto achava
        // primeiro a cópia deixada por um card que já não existia.
        this.btnToggleSizes.addEventListener('click', e => {
          e.preventDefault();

          this.showSizes(this.getDuplicatedSizesContent());
        });

        this.sizesContent.addEventListener(
          'click',
          this.handleBtnSizeClick.bind(this)
        );
      }

      if (this.swatches) {
        this.btnSwatches =
          this.swatches.querySelectorAll('.js-btn-swatch');

        this.swatches.addEventListener('change', e => {
          this.querySelector('a.card-product__media').classList.add('is-transitioning');

          const isBtnSwatch =
            e.target.classList.contains('js-btn-swatch');

          if (!isBtnSwatch) {
            return;
          }

          const btnSwatch = e.target;
          const isSwatchActive =
            btnSwatch.classList.contains('is-active');

          if (isSwatchActive) {
            return;
          }

          const btnSwatchColor = btnSwatch.dataset.colorHandle;
          const btnSwatchColorHyphenated = btnSwatchColor.toLowerCase()
            .replace(/[^a-z0-9]+/g, '-')
            .replace(/-$/, '')
            .replace(/^-/, '');

          const activeBtnSwatch = this.swatches.querySelector(
            '.js-btn-swatch.is-active'
          );

          const currentVisibleMedia = this.querySelector(
            '[class*="js-media"].is-visible'
          );
          const newVisibleMedia = this.querySelector(
            `.js-media-${btnSwatchColorHyphenated}`
          );

          activeBtnSwatch.classList.remove('is-active');
          btnSwatch.classList.add('is-active');

          if (newVisibleMedia) {
            currentVisibleMedia.classList.remove('is-visible');
            newVisibleMedia.classList.add('is-visible');
          } else if (this.defaultMedia) {
            currentVisibleMedia.classList.remove('is-visible');
            this.defaultMedia.classList.add('is-visible');
          }

          if (!this.btnToggleSizes) {
            return;
          }

          const sizeMessagesContainer =
            this.sizesContent.querySelector(
              '.js-messages.is-visible'
            );

          sizeMessagesContainer?.classList.remove('is-visible');

          const isRequesting =
            this.classList.contains('is-requesting');

          if (isRequesting) {
            return;
          }

          this.toggleBtns();

          this.querySelector('a.card-product__media').classList.remove('is-transitioning');

          const updateAvailableSizes = async () => {
            try {
              const product = await this.getProduct();

              const matchingColorVariants = product.variants.filter(
                variant => variant.options.includes(btnSwatchColor)
              );

              this.sizeBtns.forEach(sizeBtn => {
                const size = sizeBtn.dataset.size;

                let matchingSizeVariant;
                if (matchingColorVariants.length == 1) {
                  matchingSizeVariant = matchingColorVariants.find(
                    matchingColorVariant =>
                      product.variants.some(
                        variant =>
                          variant.options.includes(size) &&
                          variant.color === matchingColorVariant.color
                      )
                  );
                } else {
                  matchingSizeVariant = matchingColorVariants.find(
                    matchingColorVariant =>
                      matchingColorVariant.options.includes(size)
                  );
                }

                if (
                  matchingSizeVariant &&
                  matchingSizeVariant.available
                ) {
                  sizeBtn.setAttribute('aria-disabled', false);
                  sizeBtn.classList.remove('is-disabled');
                  if (matchingColorVariants.length == 1) {
                    sizeBtn.setAttribute(
                      'data-variantid',
                      matchingSizeVariant.id
                    );
                    sizeBtn.setAttribute(
                      'data-size',
                      matchingSizeVariant.options[0]
                    );
                    sizeBtn.setAttribute(
                      'title',
                      matchingSizeVariant.title
                    );
                  }
                  return;
                }

                sizeBtn.setAttribute('aria-disabled', true);
                sizeBtn.classList.add('is-disabled');
              });
            } catch (error) {
              console.error(error);
            } finally {
              this.toggleBtns();
            }
          };

          updateAvailableSizes();
        });
      }
    }

    async getProduct() {
      try {
        const productResponse = await fetch(
          `${window.Shopify.routes.root}products/${this.dataset.handle}.js`
        );

        const product = await productResponse.json();

        return product;
      } catch (error) {
        console.error(error);
      }
    }

    // Botões de tamanho do card e, se o popup já foi criado, os da cópia dele.
    get sizeBtns() {
      const sizeBtns = [...this.sizesContent.querySelectorAll('.js-btn-size')];

      if (this.duplicatedSizesContent) {
        sizeBtns.push(
          ...this.duplicatedSizesContent.querySelectorAll('.js-btn-size')
        );
      }

      return sizeBtns;
    }

    // O seletor de tamanhos do mobile abre num popup fixo de tela cheia, que
    // vive como cópia no fim do <body> (dentro do card, um transform ou
    // contain viraria o bloco de contenção do position: fixed). Antes, cada
    // card criava a cópia ao nascer e ela nunca saía: rolar a coleção e
    // filtrar acumulava centenas de camadas invisíveis de tela cheia, com um
    // listener de resize cada, deixando a página toda mais lenta. Agora a
    // cópia só existe depois que o cliente abre o seletor, e sai junto com o
    // card (disconnectedCallback).
    getDuplicatedSizesContent() {
      if (this.duplicatedSizesContent) {
        return this.duplicatedSizesContent;
      }

      this.duplicateSizes();
      this.setAccessibility();
      this.bindDuplicatedSizesEvents();

      // Recém-inserido, o popup ainda não tem o estado "fechado" calculado e
      // abriria sem a transição de subir. A leitura força esse cálculo.
      void this.duplicatedSizesContent.offsetWidth;

      return this.duplicatedSizesContent;
    }

    bindDuplicatedSizesEvents() {
      this.duplicatedSizesContent.addEventListener('click', e => {
        const isSizesContent = e.target.classList.contains(
          'js-sizes-content'
        );

        if (!isSizesContent) {
          return;
        }

        const sizesContent = e.target;

        this.hideSizes(sizesContent);
      });

      this.duplicatedSizesContent.addEventListener('keydown', e => {
        const isEscape = e.key === 'Escape';

        if (!isEscape) {
          return;
        }

        this.hideSizes(this.duplicatedSizesContent);
      });

      this.duplicatedSizesContent.addEventListener('keydown', e => {
        const isTabKey = e.key === 'Tab';

        if (!isTabKey) {
          return;
        }

        const isFirstElementFocused =
          document.activeElement === this.firstFocusableElement;
        const isLastElementFocused =
          document.activeElement === this.lastFocusableElement;

        if (e.shiftKey && isFirstElementFocused) {
          this.lastFocusableElement.focus();

          e.preventDefault();
        } else if (!e.shiftKey && isLastElementFocused) {
          this.firstFocusableElement.focus();

          e.preventDefault();
        }
      });

      this.duplicatedSizesContent.addEventListener(
        'click',
        this.handleBtnSizeClick.bind(this)
      );
    }

    // Só fica registrado enquanto o popup está aberto (showSizes / hideSizes):
    // no celular o resize dispara a cada vez que a barra de endereço aparece.
    onWindowResize() {
      const isSizeContentVisible =
        this.duplicatedSizesContent?.classList.contains('is-visible');

      if (!isSizeContentVisible) {
        return;
      }

      const hasHover = matchMedia('(hover: hover)').matches;

      if (DeviceDetector.isMobile() || !hasHover) {
        return;
      }

      this.hideSizes(this.duplicatedSizesContent);
    }

    // O card saiu da página (filtro, ordenação, troca do grid): o popup e os
    // listeners globais saem junto.
    disconnectedCallback() {
      if (!this.duplicatedSizesContent) {
        return;
      }

      window.removeEventListener('resize', this.onWindowResize);

      if (this._popstateHandler) {
        window.removeEventListener('popstate', this._popstateHandler);
        this._popstateHandler = null;
        this._historyPushed = false;
      }

      if (this.duplicatedSizesContent.classList.contains('is-visible')) {
        document.body.classList.remove('overflow-hidden');
      }

      this.duplicatedSizesContent.remove();
      this.duplicatedSizesContent = null;
    }

    duplicateSizes() {
      this.duplicatedSizesContent = this.sizesContent.cloneNode({
        deep: true
      });
      this.duplicatedSizesContainer = document.querySelector(
        '.js-card-sizes-duplicate'
      );

      this.focusableElements = getFocusableElements(
        this.duplicatedSizesContent
      );

      this.firstFocusableElement = this.focusableElements[0];
      this.lastFocusableElement =
        this.focusableElements[this.focusableElements.length - 1];

      if (!this.duplicatedSizesContainer) {
        this.duplicatedSizesContainer = document.createElement('div');
        this.duplicatedSizesContainer.classList.add(
          'js-card-sizes-duplicate'
        );

        document.body.insertAdjacentElement(
          'beforeend',
          this.duplicatedSizesContainer
        );
      }

      this.duplicatedSizesContainer.insertAdjacentElement(
        'beforeend',
        this.duplicatedSizesContent
      );
    }

    handleBtnSizeClick(e) {
      const isBtnSize = e.target.classList.contains('js-btn-size');

      if (!isBtnSize) {
        return;
      }

      const btnSize = e.target;
      const isDisabled = btnSize.classList.contains('is-disabled');
      const isRequesting = this.classList.contains('is-requesting');

      if (isRequesting || isDisabled) {
        return;
      }

      const btnSwatchActive = this.querySelector(
        '.js-btn-swatch.is-active'
      );

      const selectedSize = btnSize.dataset.size;
      const selectedColor = btnSwatchActive?.dataset.color;

      const selectedVariantId = btnSize.dataset.variantid
        ? btnSize.dataset.variantid
        : undefined;

      const targetSizesContent = btnSize.closest('.js-sizes-content');
      const sizeMessagesContainer =
        targetSizesContent.querySelector('.js-messages');
      const sizeMessageSuccess = targetSizesContent.querySelector(
        '.js-success-message'
      );
      const sizeMessageError = targetSizesContent.querySelector(
        '.js-error-message'
      );

      this.toggleBtns();

      const addProductToCart = async () => {
        try {
          const product = await this.getProduct();

          const matchingVariant = product.variants.find(variant => {
            if (selectedVariantId) {
              const matchesVariantId =
                variant.id == selectedVariantId;
              return matchesVariantId;
            } else {
              const matchesSize =
                variant.options.includes(selectedSize);
              const matchesColor = btnSwatchActive
                ? variant.options.includes(selectedColor)
                : true;
              return matchesSize && matchesColor;
            }
          });

          if (!matchingVariant) {
            return;
          }

          const isAvailable = matchingVariant.available;

          if (!isAvailable) {
            return;
          }

          const formData = new FormData();
          formData.append('id', matchingVariant.id);
          formData.append('quantity', 1);
          if (this.hasAttribute('data-has-pre-order')) {
            formData.append('properties[Pre-order]', '✓');
          }
          formData.append(
            'sections',
            this.cartDrawer
              .getSectionsToRender()
              ?.map(section => section.section)
          );

          // if we are on the cart page, resubmit form
          if (window.location.pathname === '/cart') {
            const cartDrawerForm = document.getElementById(
              'CartDrawer-FormSummary'
            );
            if (cartDrawerForm) {
              cartDrawerForm.submit();
            }
          }

          let sectionsToRender = [];
          if (this.cartDrawer && typeof this.cartDrawer.getSectionsToRender === 'function') {
            sectionsToRender = this.cartDrawer.getSectionsToRender()?.map(s => s.section) || [];
          } else {
            const mainCartItems = document.getElementById('main-cart-items');
            if (mainCartItems && mainCartItems.dataset && mainCartItems.dataset.id) {
              sectionsToRender.push(mainCartItems.dataset.id);
            }
            sectionsToRender.push('cart-counter');
          }

          formData.append('sections', sectionsToRender);
          formData.append('sections_url', window.location.pathname);

          const config = fetchConfig('javascript');
          config.headers['X-Requested-With'] = 'XMLHttpRequest';
          delete config.headers['Content-Type'];
          config.body = formData;

          const addToCartResponse = await fetch(
            `${routes.cart_add_url}`,
            config
          );

          const addToCartData = await addToCartResponse.json();

          if (!addToCartResponse.ok) {
            throw new Error(addToCartData.description);
          }

          sizeMessageSuccess.classList.remove('hidden');
          sizeMessageError.classList.add('hidden');

          if (this.cartDrawer && typeof this.cartDrawer.renderContents === 'function') {
            this.cartDrawer.renderContents(addToCartData, true);
          }
          if (window.location.pathname === '/cart' || !this.cartDrawer) {
            try {
              const sections = sectionsToRender;
              sections.forEach(sectionId => {
                const sectionHtml = addToCartData.sections?.[sectionId];
                if (!sectionHtml) return;
                const selector = `#shopify-section-${sectionId} cart-items`;
                const containerBySelector = document.querySelector(selector);
                const containerById = document.querySelector(`#shopify-section-${sectionId}`);

                if (containerBySelector) {
                  containerBySelector.innerHTML = new DOMParser()
                    .parseFromString(sectionHtml, 'text/html')
                    .querySelector(selector).innerHTML;
                } else if (containerById) {
                  containerById.innerHTML = new DOMParser()
                    .parseFromString(sectionHtml, 'text/html')
                    .querySelector(`#shopify-section-${sectionId}`).innerHTML;
                } else {
                  const possible = document.querySelector(`[data-id="${sectionId}"]`);
                  if (possible) {
                    const parsed = new DOMParser().parseFromString(sectionHtml, 'text/html');
                    const extracted = parsed.querySelector(`[data-id="${sectionId}"]`);
                    if (extracted)
                      possible.innerHTML = extracted.innerHTML;
                  }
                }
              });

              document.dispatchEvent(
                new CustomEvent('cart:updated', {
                  detail: addToCartData
                })
              );
            } catch (replaceError) {
              console.error(replaceError);
            }
          }
        } catch (error) {
          const errorTextEl =
            sizeMessageError.querySelector('[data-text]');

          sizeMessageSuccess.classList.add('hidden');
          sizeMessageError.classList.remove('hidden');

          errorTextEl.textContent = error.message;
        } finally {
          this.toggleBtns();

          sizeMessagesContainer.classList.add('is-visible');
          setTimeout(() => {
            sizeMessagesContainer.classList.remove('is-visible');
          }, 4000);

          // Remove is-visible class on mobile after adding product to cart
          if (DeviceDetector.isMobile()) {
            // `?.`: o clique pode ter vindo dos tamanhos do próprio card (sem
            // popup criado), ou o card pode ter saído da página durante o fetch.
            this.duplicatedSizesContent?.classList.remove('is-visible');
            if (this.cartDrawer?.classList.contains('is-visible')) {
              return;
            }
            document.body.classList.remove('overflow-hidden');
          }
        }
      };

      addProductToCart();
    }

    setAccessibility() {
      const duplicatedSizesContentId = `SizesPopup-${this.sizesContent.dataset.id}`;

      this.duplicatedSizesContent.id = duplicatedSizesContentId;
      this.btnToggleSizes.setAttribute('aria-expanded', false);
      this.btnToggleSizes.setAttribute(
        'aria-controls',
        duplicatedSizesContentId
      );
    }

    toggleBtns() {
      this.classList.toggle('is-requesting');
      this.btnSwatches?.forEach(btnSwatch =>
        btnSwatch.toggleAttribute('disabled')
      );

      if (!this.btnToggleSizes) {
        return;
      }

      this.sizesContent.classList.toggle('overlay-visible');
      // Criado no meio de uma requisição, o popup já nasce com a classe copiada
      // do card, e o toggle final tira dos dois juntos.
      this.duplicatedSizesContent?.classList.toggle('overlay-visible');
    }

    showSizes(container) {
      this.btnToggleSizes.setAttribute('aria-expanded', true);
      container.classList.add('is-visible');
      document.body.classList.add('overflow-hidden');
      this.firstFocusableElement.focus();
      window.addEventListener('resize', this.onWindowResize);

      // History integration: botão voltar do mobile fecha o seletor em vez de navegar fora da página
      this._openSizesContainer = container;
      if (!this._historyPushed) {
        this._historyPushed = true;
        try {
          history.pushState({ cardSizesOpen: true }, '', location.href);
        } catch (e) {
          this._historyPushed = false;
        }
        this._popstateHandler = () => {
          if (this._openSizesContainer && this._openSizesContainer.classList.contains('is-visible')) {
            this._skipHistoryBack = true;
            this.hideSizes(this._openSizesContainer);
          }
        };
        window.addEventListener('popstate', this._popstateHandler);
      }
    }

    hideSizes(container) {
      this.btnToggleSizes.setAttribute('aria-expanded', false);
      container.classList.remove('is-visible');
      document.body.classList.remove('overflow-hidden');
      this.btnToggleSizes.focus();
      window.removeEventListener('resize', this.onWindowResize);

      // History integration: remove a entrada fake do history se o fechamento não veio do botão voltar
      if (this._historyPushed) {
        this._historyPushed = false;
        this._openSizesContainer = null;
        if (this._popstateHandler) {
          window.removeEventListener('popstate', this._popstateHandler);
          this._popstateHandler = null;
        }
        if (!this._skipHistoryBack) {
          try {
            history.back();
          } catch (e) {}
        }
        this._skipHistoryBack = false;
      }
    }
  }

  customElements.define('card-product', CardProduct);
}
